import DefaultApiService from "./default";

const unwrap = (res) => res?.data ?? res?.Data ?? null;

const CreditInquiryApi = {
  getSummary: async (apiBase, requestInfoId) => {
    const res = await DefaultApiService.getApi(
      `${apiBase}/GetCreditInquirySummary`,
      { requestInfoId }
    );
    return unwrap(res);
  },

  retry: async (apiBase, requestInfoId) => {
    const res = await DefaultApiService.postApi(
      `${apiBase}/RetryCreditInquiry?requestInfoId=${Number(requestInfoId)}`,
      {}
    );
    return res;
  },

  retryGuarantor: async (apiBase, requestInfoId) => {
    const res = await DefaultApiService.postApi(
      `${apiBase}/RetryGuarantorCreditInquiry?requestInfoId=${Number(requestInfoId)}`,
      {}
    );
    return res;
  },
};

export default CreditInquiryApi;
